import React, { Component } from 'react'
import LessonCard from '../LessonCard'
import { Row, Button, Col } from 'reactstrap'


export default class SimulateItem extends Component {



    render(){
        const {singleItem} = this.props;
        return (
            singleItem &&   <LessonCard
                            iconClass={`screen-eye-icon`}
                            heading={`Simulate Item`}
                            isCollapsable={false}
                            headerButtons={[
                                <Button className={`add-btn`}>+ Edit Item</Button>
                            ]}

                        >
                            <div className='items-bank-right-container' style={{ height: 'unset' }}>
                                    <div className='item-card' style={{ margin: '20px 0px 20px 0px' }}>
                                        <Row>
                                            <Col md='12' className='simulate-label item-label'>
                                                {`Question #${singleItem.itemCode.split('Q')[1]}`}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md='12' className='simulate-desc item-desc'>
                                                <div dangerouslySetInnerHTML={{ __html: singleItem.preview }}></div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md='12' className='simulate-desc item-desc'>
                                                {Object.keys(singleItem.answerChoices).map((key, i) => {
                                                    let answers = ['A', 'B', 'C', 'D']
                                                    return (
                                                        <div className='answers'>
                                                            <div className='answer-circle'>{answers[i]}</div>
                                                            <div className='answer-choice'>{singleItem.answerChoices[key]}</div>
                                                        </div>
                                                    )
                                                })}
                                                <Button className={`add-btn`} style={{ margin: '20px 0 0 10px' }}>Submit Answer</Button>
                                            </Col>

                                        </Row>
                                    </div>
                            </div>
                        </LessonCard>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorItemsCards/SimulateItem.js